// @flow
import _ from 'lodash'

import type { ValidatedAdvertisementWithStoredMedia } from './types'
import { advertisementsPayload } from './prepareProviderTemplateBlocks'
import type { RequestPayload } from './prepareProviderTemplateBlocks'
import { getAdvertisement, hasAdvertisementAnyErrors } from '../redux/selectors'
import type { Store } from '../redux/ducks'
import type { PlacementType } from './AudienceEdit/PlacementTypeSelect'

type Options = {|
  state: Store,
  storeIds: Array<string>,
  providers: Array<string>,
  disabledStoreIds: Array<string>,
  audienceType: string,
  placementType: PlacementType,
  vkPlacement: string
|}

export default class AdvertisementsKeeper {
  options: Options
  state: Store
  storeIds: Array<string>
  providers: Array<string>
  disabledStoreIds: Array<string>
  audienceType: string
  placementType: PlacementType
  vkPlacement: string

  constructor(options: Options) {
    this.options = options
    this.state = options.state
    this.storeIds = options.storeIds
    this.providers = options.providers
    this.disabledStoreIds = options.disabledStoreIds
    this.audienceType = options.audienceType
    this.placementType = options.placementType
    this.vkPlacement = options.vkPlacement
  }

  hasErrors() {
    return !_.every(
      this.storeIds,
      (storeId) =>
        _.includes(this.disabledStoreIds, storeId) ||
        !hasAdvertisementAnyErrors(this.state, storeId)
    )
  }

  advertisementsForRequest(): Array<ValidatedAdvertisementWithStoredMedia> {
    const enabledStoreIds = _.filter(
      this.storeIds,
      (storeId) => !_.includes(this.disabledStoreIds, storeId)
    )
    return _.map(enabledStoreIds, (storeId) => getAdvertisement(this.state, storeId))
  }

  advertisementsToOutput(): RequestPayload {
    return advertisementsPayload(
      this.advertisementsForRequest(),
      this.providers,
      this.audienceType,
      this.placementType,
      this.vkPlacement
    )
  }
}
